import React from "react";
import { View, Pressable, StyleSheet } from "react-native";
import { FileText } from "lucide-react";
import CustomText from "../../../common/general/CustomText/CustomText";
import { spacing, colors, radii, typographyScale } from "../../../../styles/design-system";

export interface AssignmentSuggestion {
  id: string;
  title?: string | null;
  due_date?: string | null;
}

interface AssignmentSuggestionCardProps {
  assignment: AssignmentSuggestion;
  onPress: (assignment: AssignmentSuggestion) => void;
  isHovered?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const AssignmentSuggestionCard: React.FC<AssignmentSuggestionCardProps> = ({
  assignment,
  onPress,
  isHovered = false,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Pressable
      style={[styles.assignmentItem, isHovered && styles.assignmentItemHovered]}
      onPress={() => onPress(assignment)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <View style={styles.assignmentContent}>
        <View style={styles.assignmentTitleRow}>
          <FileText size={20} color={colors.brand[500]} style={styles.assignmentIcon} />
          <CustomText
            text={assignment.title || "Untitled Assignment"}
            useTranslationText={false}
            style={styles.assignmentName}
            numberOfLines={1}
          />
        </View>
        {assignment.due_date && (
          <CustomText
            text={`Due ${new Date(assignment.due_date).toLocaleDateString(undefined, {
              weekday: "short",
              month: "short",
              day: "numeric",
            })}`}
            useTranslationText={false}
            style={styles.assignmentDate}
          />
        )}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  assignmentItem: {
    paddingVertical: 12,
    paddingHorizontal: spacing.sm,
    borderRadius: radii.lg,
    marginBottom: spacing.xs,
    cursor: "pointer",
    borderWidth: 1,
    borderColor: colors.grey[200],
  },
  assignmentItemHovered: {
    backgroundColor: colors.brand[50],
    borderColor: colors.brand[300],
  },
  assignmentContent: {
    flex: 1,
  },
  assignmentTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: spacing.xxs,
  },
  assignmentIcon: {
    marginRight: spacing.xs,
  },
  assignmentName: {
    fontSize: typographyScale.textSm.fontSize,
    color: colors.grey[900],
    fontWeight: "500",
    flex: 1,
  },
  assignmentDate: {
    fontSize: typographyScale.textXs.fontSize,
    color: colors.grey[500],
    marginLeft: 28,
  },
});
